/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import * as RadioGroup from '@radix-ui/react-radio-group';
import { useDispatch } from 'react-redux';
import { Box, Button, BrowserFrame, Text, Masonry, Vertical } from '@components/design-system';
import { actions } from '@state/settings';
import { ISlide } from './interface';
import { RadioItem } from './radio-item';

export const Layout: FC<ISlide> = ({ values, handleChange, handleStep }) => {
  const dispatch = useDispatch();

  const handleValueChange = (nextValue: string) => {
    if (handleChange) {
      handleChange('masonry', nextValue === 'masonry');
    }
    dispatch({ type: actions.SETTINGS_CHANGE_APPEARANCE_MASONRY, payload: nextValue === 'masonry' });
  };

  const handleClick = () => {
    handleValueChange(values.masonry ? 'masonry' : 'vertical');
    if (handleStep) handleStep(+1);
  };

  return (
    <>
      <Box css={{ width: '100%', backgroundColor: '$secondaryBackground' }} horizontal>
        <Box css={{ marginTop: 32, height: 150, overflow: 'hidden' }}>
          <BrowserFrame>{values.masonry ? <Masonry /> : <Vertical />}</BrowserFrame>
        </Box>
      </Box>

      <Box css={{ width: '100%', padding: '$space$3', flexDirection: 'column' }}>
        <Text as="h6" css={{ textAlign: 'center' }}>
          Layout
        </Text>

        <Text css={{ color: '$secondaryFill', fontSize: 14, textAlign: 'center' }}>
          Choose a layout that works for you
        </Text>

        <RadioGroup.Root value={values.masonry ? 'masonry' : 'vertical'} onValueChange={handleValueChange} asChild>
          <Box
            css={{
              width: '100%',
              flexDirection: 'column',
              '&>*': { marginBottom: '$space$4', '&:last-child': { marginBottom: 'unset' } },
            }}
          >
            <RadioItem value="masonry" label="Masonry" />
            <RadioItem value="vertical" label="Vertical" />
          </Box>
        </RadioGroup.Root>
      </Box>

      <Box css={{ padding: '$space$3', justifyContent: 'space-between' }} vertical>
        <Box css={{ color: '$secondaryFill', fontSize: 12 }}>1 / 5</Box>
        <Box>
          <Button variant="secondary" onClick={handleClick}>
            Next
          </Button>
        </Box>
      </Box>
    </>
  );
};
